// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSecDiv_root__7BBMF","freeBox":"PlasmicSecDiv_freeBox__6flO3","sectionHeader":"PlasmicSecDiv_sectionHeader__br24E"};